import React from 'react';
import { Link } from 'react-router-dom';
import { brandProducts } from './brand-products';
import ProductPhoto from './ProductPhoto';
import './home.css';

const featured = brandProducts;

export default function Home() {
  return <main className="home-page" id="top">
    <header className="home-header">
      <Link className="home-wordmark" to="/" aria-label="PARALYZE AREA ホーム"><img src="/brand/scorpion-symbol.svg" alt=""/>PARALYZE AREA</Link>
      <nav aria-label="メインナビゲーション">
        <Link className="home-nav-primary" to="/catalog">ITEMS</Link>
        <Link to="/museum">EXHIBITION</Link>
        <a href="#about">ABOUT</a>
        <a href="#contact">CONTACT</a>
      </nav>
    </header>
    <section className="home-intro" aria-labelledby="home-title">
      <div className="home-intro-top"><span>PARALYZE AREA / OFFICIAL</span><span>DROP 001 · VISUAL STUDIES</span></div>
      <div className="home-intro-body">
        <div>
          <p className="home-eyebrow">A WORLD IN PROGRESS</p>
          <h1 id="home-title">PARALYZE<br/><em>AREA</em><span className="home-period">.</span></h1>
          <p className="home-intro-statement">しびれるモチーフ。<br/>身につける、飾る、その前のアイデア。</p>
          <Link className="home-intro-cta" to="/catalog">7つのアイテムを見る <span aria-hidden="true">↗</span></Link>
        </div>
        <Link className="home-intro-aside" to="/items/scorpion-chest-tee" aria-label="SCORPION CHEST TEE のデザインを見る">
          <div className="home-intro-aside-image"><ProductPhoto product={brandProducts[0]} loading="eager"/></div>
          <p><small>01 / FEATURED STUDY</small><strong>SCORPION CHEST TEE</strong><span>デザインを見る ↗</span></p>
        </Link>
      </div>
      <div className="home-intro-bottom"><a href="#items">アイテムを少し見る <span aria-hidden="true">↓</span></a><span>EXPLORE DROP 001</span></div>
    </section>
    <section className="home-items home-section" id="items" aria-labelledby="items-title">
      <div className="home-items-heading"><div><p className="home-section-index">01 / DROP 001</p><h2 id="items-title">ITEMS <small>制作中のアイテム / 7 STUDIES</small></h2></div><Link to="/catalog">一覧を見る <span aria-hidden="true">↗</span></Link></div>
      <p className="home-items-note">掲載画像はAI MOCKUP（暫定イメージ）です。実際の商品・仕様・価格・販売日は未確定。現在はデザインの紹介のみ行っています。</p>
      <nav className="home-motifs" aria-label="モチーフから探す">
        <span>FIND A MOTIF</span><Link to="/catalog#scorpion-chest-tee">SCORPION ↗</Link><Link to="/catalog#jellyfish-hem-tee">JELLYFISH ↗</Link><Link to="/catalog#snake-chest-tee">SNAKE ↗</Link><Link to="/catalog#puffer-mug">PUFFER ↗</Link>
      </nav>
      <div className="home-featured">{featured.map((product, index)=><Link to={'/items/' + product.slug} className="home-feature" key={product.slug}>
        <div className="home-feature-image"><ProductPhoto product={product} loading={index === 0 ? 'eager' : 'lazy'}/></div>
        <div className="home-feature-caption"><span>0{index + 1} / DESIGN STUDY</span><strong>{product.name}</strong><small className="home-feature-status">AI MOCKUP / 販売準備中</small><span>詳細を見る ↗</span></div>
      </Link>)}</div>
      <Link className="home-catalog-cta" to="/catalog">7つのアイテムをすべて見る <span aria-hidden="true">↗</span></Link>
    </section>
    <section className="home-works home-section" id="works" aria-labelledby="works-title">
      <div className="home-section-head"><p className="home-section-index">02 / CREATIVE WORKS</p><h2 id="works-title">ブランドの外側へ。</h2></div>
      <div className="home-works-list">
        <div><span>01</span><h3>GRAPHIC</h3><p>サソリ、クラゲ、ヘビ。モチーフを育てるデザイン。</p></div>
        <div><span>02</span><h3>GAME &amp; CHARACTER</h3><p>ゲームやキャラクターの制作活動。</p></div>
        <div><span>03</span><h3>EXHIBITION</h3><p>アイテムを巡るオンライン展示。商品詳細とは別の体験です。</p><Link to="/museum">展示空間へ ↗</Link></div>
      </div>
    </section>
    <section className="home-about home-section" id="about" aria-labelledby="about-title">
      <p className="home-section-index">03 / ABOUT THE BRAND</p>
      <div><h2 id="about-title">PARALYZE AREAとは</h2><p>PARALYZE AREAは、サソリやクラゲ、ヘビなどのモチーフを起点に、ビジュアルと作品を展開するブランドです。ここでは、その世界観と販売準備中のアイテムを紹介しています。</p></div>
    </section>
    <section className="home-contact home-section" id="contact" aria-labelledby="contact-title">
      <div><p className="home-section-index">04 / COMPANY &amp; CONTACT</p><h2 id="contact-title">運営・お問い合わせ</h2><p>運営会社の情報は会社サイトから。PARALYZE AREAへのご連絡は公式TikTokのプロフィールをご確認ください。</p></div>
      <div className="home-contact-links"><a href="https://eeek-inc.com/" target="_blank" rel="noopener noreferrer">会社サイト <span aria-hidden="true">↗</span></a><a href="https://www.tiktok.com/@paralyze_area" target="_blank" rel="noopener noreferrer">TikTok @paralyze_area <span aria-hidden="true">↗</span></a></div>
    </section>
    <footer className="home-footer"><Link to="/">PARALYZE AREA</Link><nav aria-label="フッターナビゲーション"><Link to="/catalog">ITEMS</Link><Link to="/museum">EXHIBITION</Link><a href="https://eeek-inc.com/" target="_blank" rel="noopener noreferrer">COMPANY ↗</a></nav><span>© PARALYZE AREA</span></footer>
  </main>;
}
